// extracted by mini-css-extract-plugin
export default {"bread_cmp":"BreadCrumb_bread_cmp__6nKmP","ant_bread_cmp":"BreadCrumb_ant_bread_cmp__V4UBd"};